import SVG from 'components/renderSvg';
import React from 'react';
import plusIcon from 'media/svgs/plus.svg';
const Button = ({
  variant,
  onClick,
  title = 'Submit',
  disabled,
  icon,
  iconRight = false,
  type = 'submit',
  className = '',
  form = '',
  isplus = false,
  loading = false,
  loadingTitle = 'Loading...',
  dataCy,
  ...props
}) => {
  const baseStyle = `px-6 h-10 flex justify-center items-center text-center text-sm font-semibold rounded-xl transition-all duration-200 ease-in-out transform active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-gray-900 ${className}`;
  const variantStyles = {
    primary: 'bg-black text-white hover:bg-gray-800 shadow-md shadow-gray-200',
    secondary: 'bg-white text-black border border-gray-200 hover:bg-gray-50 hover:border-black',
    danger: 'bg-white text-black border border-gray-200 hover:bg-gray-50 hover:border-black', // Keep it minimal
    success: 'bg-black text-white hover:bg-gray-800 shadow-md shadow-gray-200',
    outline:
      'bg-transparent border border-gray-200 hover:border-black hover:bg-transparent text-black',
  };

  const disabledStyle = disabled || loading
    ? 'opacity-50 !bg-gray-400  cursor-not-allowed'
    : '';

  return (
    <button
      className={`${baseStyle} ${variantStyles[variant]}  ${disabledStyle}`}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      data-cy={dataCy}
      {...(form ? { form: form } : {})}
      {...props}
    >
      {loading && (
        <span className="order-1 pr-2">
          <svg
            className="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </span>
      )}

      {!loading && icon && (
        <span className={` ${iconRight ? 'order-2 pl-2' : 'order-1 pr-2'}`}>
          {/* Implement your icon rendering logic here */}
          {icon}
        </span>
      )}

      <span
        className={`text-[16px] font-normal  ${iconRight ? 'order-2' : 'order-2'}`}
      >
        {loading ? loadingTitle : title}
      </span>

      {!loading && isplus && (
        <span className={` ${iconRight ? 'order-1 pr-2' : 'order-2 pl-2'}  `}>
          <SVG icon={plusIcon} />
        </span>
      )}
    </button>
  );
};

export default Button;
